module.exports = __webpack_public_path__ + "img/g1.bcf06467.png";